import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "hint-popover",
  templateUrl: "./hint-popover.component.html",
  styleUrls: ["./hint-popover.component.scss"],
})
export class HintPopoverComponent implements OnInit {
  @Input() key: string;
  @Input() value: number;
  @Input() placement: string = 'top';
  @Input() iconColor: string;
  @Input() customIcon?: string;

  constructor() {}

  ngOnInit(): void {}
}
